import { Flex, Typography } from 'antd';

export function SignedOut() {
  return (
    <Flex vertical align="center" justify="center" gap="middle" data-testid="signed-out-view">
      <Typography.Title level={3}>You&apos;ve been signed out</Typography.Title>
      <Typography.Text type="secondary">Sign in again to continue.</Typography.Text>
    </Flex>
  );
}
